export const ACCESS_TOKEN = "token";
export const DEVICE = "device";
export const USER_INFO = 'USER_INFO';
export const LANG = 'LANG';
